// Add the work WhatsApp alongside the shop landline, including editable page/policy copy.
(() => {
  const phone = /(?:\+44\s*115|0115)[\s.-]*973[\s.-]*7888/;
  const excluded = 'a,script,style,noscript,textarea,input,select,option,button,svg,[contenteditable="true"],[data-welch-phone-contact]';
  function link() {
    const a = document.createElement('a');
    a.href = 'https://wa.me/447462324301';
    a.className = 'welch-whatsapp';
    a.setAttribute('aria-label', 'WhatsApp us on 07462 324301');
    a.innerHTML = "<img class=\"welch-whatsapp__logo\" src=\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3MjAgNzIwIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjMjVkMzY2OwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0zNjAsMEMxNjEuMTgsMCwwLDE2MS4xOCwwLDM2MGMwLDY1LjQxLDE3LjQ1LDEyNi43NSw0Ny45NCwxNzkuNjFMMCw3MjBsMTg3LjAyLTQ0LjIxYzUxLjM0LDI4LjE4LDExMC4yOCw0NC4yMSwxNzIuOTgsNDQuMjEsMTk4LjgyLDAsMzYwLTE2MS4xOCwzNjAtMzYwUzU1OC44MiwwLDM2MCwwWk0zNjAsNjU1LjUyYy02MC4xNywwLTExNi4xMy0xNy45OC0xNjIuODItNDguODdsLTExMC40OSwyOC4xNCwzMC45OS0xMDUuNjFjLTMzLjUzLTQ3LjkzLTUzLjItMTA2LjI2LTUzLjItMTY5LjE5LDAtMTYzLjIxLDEzMi4zMS0yOTUuNTIsMjk1LjUyLTI5NS41MnMyOTUuNTIsMTMyLjMxLDI5NS41MiwyOTUuNTItMTMyLjMxLDI5NS41Mi0yOTUuNTIsMjk1LjUyWiIvPgogIDxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTQ0NC4zNSw0MDcuNTJsODcuMSw0MS4wNmM0LDEuODgsNi41Niw1Ljk0LDYuMiwxMC4zNC0uOTQsMTEuNDYtNS41NCwzNC40My0yNi4xMyw1NS4wMi01OC4xMiw1OC4xMi0xNjIuNDktNy42NC0xNjYuNzQtMTAuMTgtMjUuNjctMTMuNzktNTAuMDYtMzIuMjQtNzMuMTktNTUuMzYtMjMuMTItMjMuMTItNDEuNTgtNDcuNTItNTUuMzctNzMuMTktMi41NS00LjI0LTY4LjMxLTEwOC42MS0xMC4xOC0xNjYuNzQsMjAuNTktMjAuNTksNDMuNTYtMjUuMTksNTUuMDItMjYuMTMsNC40MS0uMzYsOC40NiwyLjIsMTAuMzQsNi4ybDQxLjA3LDg3LjFjMS45NCw0LjEyLDEuMDksOS4wMi0yLjEzLDEyLjI0bC0zMC42MSwzMC42MWMtNi42Miw2LjYyLTguNTYsMTYuOTMtNCwyNS4xMSwxMS4xNywyMC4wMywyNi4xOSwzOS4zMiw0My41OSw1Ny4wNywxNy43NSwxNy40LDM3LjA0LDMyLjQzLDU3LjA3LDQzLjU5LDguMTgsNC41NiwxOC40OCwyLjYyLDI1LjExLTRsMzAuNjEtMzAuNjFjMy4yMi0zLjIyLDguMTItNC4wOCwxMi4yNC0yLjEzWiIvPgo8L3N2Zz4=\" width=\"22\" height=\"22\" alt=\"\"><span class=\"welch-whatsapp__copy\"><span class=\"welch-whatsapp__title\">WhatsApp</span></span>";
    return a;
  }
  function pair(node) {
    const group = document.createElement('span');
    group.className = 'welch-phone-contact';
    group.dataset.welchPhoneContact = '';
    const paragraph = node.parentElement.closest('p');
    const prose = paragraph && paragraph.textContent.trim().length > 80;
    node.before(group); group.append(node);
    if (prose) {
      // Keep help text readable: put the contact action after the complete sentence.
      if (!paragraph.querySelector('[data-welch-whatsapp-prose]')) {
        const action = document.createElement('span');
        action.dataset.welchWhatsappProse = '';
        action.className = 'welch-whatsapp-prose';
        action.append(link()); paragraph.append(action);
      }
    } else group.append(link());
  }
  function enhance(root) {
    if (!(root instanceof Element)) return;
    const anchors = [...(root.matches('a[href^="tel:"]') ? [root] : []), ...root.querySelectorAll('a[href^="tel:"]')];
    for (const a of anchors) {
      const digits = a.getAttribute('href').replace(/\D/g, '');
      if (['01159737888','441159737888'].includes(digits) && !a.closest('[data-welch-phone-contact]')) pair(a);
    }
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (phone.test(node.textContent) && !node.parentElement.closest(excluded)) nodes.push(node);
    }
    for (const node of nodes) {
      // Split only the phone number; retain the surrounding merchant-authored wording.
      const match = phone.exec(node.textContent);
      const number = node.splitText(match.index);
      number.splitText(match[0].length);
      pair(number);
    }
  }
  const floating = link();
  floating.className = 'welch-whatsapp-floating';
  floating.setAttribute('aria-label', 'Chat with Welch on WhatsApp');
  floating.querySelector('.welch-whatsapp__copy').textContent = 'Chat with us';
  document.body.append(floating);
  let pending = false;
  function positionChat() {
    pending = false;
    let bottom = 24;
    for (const bar of document.querySelectorAll('.sticky-add-to-cart__bar[data-stuck="true"]')) {
      const rect = bar.getBoundingClientRect();
      if (rect.height && rect.top < window.innerHeight && rect.bottom > 0) bottom = Math.max(bottom, window.innerHeight - rect.top + 16);
    }
    floating.style.setProperty('--welch-chat-bottom', `${bottom}px`);
  }
  function queuePosition() {
    if (!pending) { pending = true; requestAnimationFrame(positionChat); }
  }
  window.addEventListener('scroll', queuePosition, {passive:true});
  window.addEventListener('resize', queuePosition, {passive:true});
  new MutationObserver(queuePosition).observe(document.body, {subtree:true, attributes:true, attributeFilter:['data-stuck']});
  if (typeof ResizeObserver !== 'undefined') {
    const sizes = new ResizeObserver(queuePosition);
    for (const bar of document.querySelectorAll('.sticky-add-to-cart__bar')) sizes.observe(bar);
  }
  queuePosition();
  enhance(document.body);
  new MutationObserver(records => {
    const roots = new Set();
    for (const record of records) {
      if (record.type === 'characterData') roots.add(record.target.parentElement);
      for (const node of record.addedNodes) roots.add(node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement);
    }
    for (const root of roots) if (root?.isConnected && !root.closest('[data-welch-phone-contact]')) enhance(root);
  }).observe(document.body, {childList:true, subtree:true, characterData:true});
})();
